<template>
  <div>
    <div class="header">
      역할
    </div>
	<instructor-role-inline-form
	 v-for="item in items"
	 :key="item.id"
	 :data="item"
	 :is-active="item.id === activeRoleId"/>
  </div>
</template>

<script>
import InstructorRoleInlineForm from "./InstructorRoleInlineForm.vue"

export default {
	name: "InstructorRole",
	components: { InstructorRoleInlineForm },
	props: ["items", "activeRoleId"],
	data() {
		return {
			isCreating: false,
		};
	},
	watch: {
		activeRoleId(id) {
			let activeItem = this.items.find(item => item.id === id);
			this.$emit("selectRole", activeItem);
		},
	},
};
</script>

<style lang="scss">
.role-item {
	height: 40px;
	border-radius: 6px;
	padding: 10px 10px 10px 40px;
	box-sizing: border-box;
	margin-bottom: 2px;
	position: relative;
	color: #4a4a4a;
	display: flex;

	&.add {
		margin-top: 20px;

		span {
			color: #9b9b9b;
		}
	}

	&.view:hover,
	&.add:hover {
		background-color: #f0f0f0;
		cursor: pointer;
	}

	&.active {
		background-color: #9b9b9b;
		color: #ffffff;

		&:hover {
			background-color: #919191;
			cursor: pointer;
		}
	}

	input {
		flex: 1;
		height: 20px;
		font-size: 14px;
		font-style: normal;
		font-stretch: normal;
		line-height: 1.43;
		letter-spacing: -0.8px;
		background-color: transparent;
		border: 0;

		@media screen and (max-width: 768px) {
			width: calc(100% - 70px);
		}
	}

	input::placeholder {
		color: #d3d3d3;
	}

	input:focus {
		outline: none;
	}

	.folder-icon {
		position: absolute;
		top: 5px;
		left: 5px;
		width: 30px;
	}

	span {
		display: inline-block;
		line-height: 20px;
		font-size: 14px;
		font-weight: normal;
		letter-spacing: -0.8px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		flex: 1;
	}
}
</style>
